import { useApiUrl } from '@gemini/lux-ds-pms';
import { OBRoutes } from '@utils/apiRoutes';
import { ScheduleConfigDTO } from '@utils/interfaces';
import { useOBQuery } from '@hooks/useOBQuery';

interface SchedulingConfigProps {
  practiceId: string;
}

const useSchedulingConfig = ({ practiceId }: SchedulingConfigProps) => {
  const url = useApiUrl(
    OBRoutes.SchedulConfig,
    'ONLINEBOOKING_CLIENT_BFF_API_BASE_URL',
  )?.replace('##practiceId', practiceId);

  return useOBQuery<ScheduleConfigDTO>(url, {
    enabled: !!url && !!practiceId,
  });
};

export default useSchedulingConfig;
